export const brandMap = {
  "BABY": "Baby",
  "BABY BOY": "Baby Boy",
  "BABY GIRL": "Baby Girl",
  "BIG & TALL": "Big & Tall",
  "BIG PONY": "Big Pony",
  "BLACK LABEL WOMEN": "Black Label Women",
  "BOYS": "Boys",
  "BOYS 1.5-6 YEARS": "Boys 1.5-6 Years",
  "BOYS 2-7": "Boys 2-7",
  "BOYS 2-7/GIRLS 2-6X": "Boys 2-7/Girls 2-6x",
  "BOYS 6-14 YEARS": "Boys 6-14 Years",
  "BOYS 8-18": "Boys 8-18",
  "BOYS 8-20": "Boys 8-20",
  "BOYS 8-20/GIRLS 7-16": "Boys 8-20/Girls 7-16",
  "BOYS/GIRLS": "Boys/Girls",
  "CHILD": "Child",
  "CHILDREN": "Children",
  "COLLECTION APPAREL": "Collection Apparel",
  "CREATE YOUR OWN": "Create Your Own",
  "GIRLS": "Girls",
  "GIRLS 1.5-6.5 YEARS": "Girls 1.5-6.5 Years",
  "GIRLS 2-16": "Girls 2-16",
  "GIRLS 2-6X": "Girls 2-6x",
  "GIRLS 2-6X,GIRLS 1.5-6.5 YEARS": "Girls 2-6x,Girls 1.5-6.5 Years",
  "GIRLS 7-14 YEARS": "Girls 7-14 Years",
  "GIRLS 7-16": "Girls 7-16",
  "GIRLS 7-16,GIRLS 7-14 YEARS": "Girls 7-16,Girls 7-14 Years",
  "GIRLSâ€™ COLLECTION 2-6X": "Girlsâ€™ Collection 2-6x",
  "GIRLSâ€™ COLLECTION 7-16": "Girlsâ€™ Collection 7-16",
  "JUNIOR": "Junior",
  "LAUREN": "Lauren",
  "LAUREN HOME": "Lauren Home",
  "LAUREN PETITE": "Lauren Petite",
  "LAUREN RALPH LAUREN": "Lauren Ralph Lauren",
  "LAUREN WOMAN": "Lauren Woman",
  "PERSONALIZATION": "Personalization",
  "PINK PONY": "Pink Pony",
  "POLO": "Polo",
  "POLO 67": "Polo 67",
  "POLO BLACK": "Polo Black",
  "POLO BLUE": "Polo Blue",
  "POLO DENIM & SUPPLY": "Polo Denim & Supply",
  "POLO EARTH": "Polo Earth",
  "POLO GOLF": "Polo Golf",
  "POLO RALPH LAUREN": "Polo Ralph Lauren",
  "POLO RALPH LAUREN HOME": "Polo Ralph Lauren Home",
  "POLO RED": "Polo Red",
  "POLO SPORT": "Polo Sport",
  "POLO TENNIS": "Polo Tennis",
  "PURPLE LABEL": "Purple Label",
  "RALPH LAUREN": "Ralph Lauren",
  "RALPH LAUREN COLLECTION": "Ralph Lauren Collection",
  "RALPH LAUREN GOLF": "Ralph Lauren Golf",
  "RALPH LAUREN HOME": "Ralph Lauren Home",
  "RALPH LAUREN VINTAGE": "Ralph Lauren Vintage",
  "RALPH ROCKS": "Ralph Rocks",
  "RALPH'S CLUB": "Ralph's Club",
  "RL COLLECTION": "RL Collection",
  "RLX": "RLX",
  "RLX GOLF": "RLX Golf",
  "ROMANCE": "Romance",
  "RRL": "Double RL",
  "THE 867 COLLECTION": "The 867 Collection",
  "THE AMERICAN WESTERN COLLECTION": "The American Western Collection",
  "THE AUTOMOTIVE COLLECTION": "The Automotive Collection",
  "THE CHUNKY CHAIN COLLECTION": "The Chunky Chain Collection",
  "THE EQUESTRIAN COLLECTION": "The Equestrian Collection",
  "THE HERITAGE COLLECTION": "The Heritage Collection",
  "THE NAUTICAL COLLECTION": "The Nautical Collection",
  "THE RL888 COLLECTION": "The Rl888 Collection",
  "THE SAFARI COLLECTION": "The Safari Collection",
  "THE SLIM CLASSIQUE COLLECTION": "The Slim Classique Collection",
  "THE STIRRUP COLLECTION": "The Stirrup Collection",
  "TODDLER": "Toddler",
  "WOMAN": "Woman",
  "WOMAN BY RALPH LAUREN": "Woman By Ralph Lauren",
  "RALPH LAUREN JEWELRY": "Ralph Lauren Jewelry",
  "GIRLS' COLLECTION 2-6X": "Girls' Collection 2-6x",
  "GIRLS' COLLECTION 7-16": "Girls' Collection 7-16"
};